import React from 'react';
import type { ChartHeaderProps } from '../chart-header';
import ChartPanel from '../chart-panel';
import ChartHeader from '../chart-header';

type ChartProps = { panelClassName?: string; header?: boolean } & ChartHeaderProps;
const Chart: React.FC<ChartProps> = ({ panelClassName, header = true, children, ...props }) => {
  return (
    <ChartPanel className={panelClassName}>
      <>
        {header && <ChartHeader {...props}></ChartHeader>}
        {children}
      </>
    </ChartPanel>
  );
};

export default Chart;
